import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import logo from "../Images/buillogo6.png";
import anotherLogo from "../Images/OGGS_Logo.png";

const generateInvoice = (sellerDetails, products, invoiceId, totalAmount ,saleType) => {
  const doc = new jsPDF();
  const formattedDate = dayjs().format("DD MMMM YYYY");

  // GST & Subtotal Calculation
  const gstRate = 0.18;
  const gstAmount = totalAmount * gstRate;
  const subTotal = totalAmount - gstAmount;

  // Additional Charges (Update as needed)
  let visibilityCharges = 0;
  let depositCharges = 0;
  const powerPackCharges = 0; // Modify as needed

  if (saleType === "Sale By Seller") {
    visibilityCharges = subTotal * 0.1; // Example: 10% of subtotal (Modify if needed)
  }

  if (saleType === "Sale By OGCS") {
    depositCharges = subTotal * 0.2; // Example: 20% of subtotal (Modify if needed)
  }
  
  console.log("📌 Invoice Debugging:");
  console.log("🟢 Selected Products:", products);
  console.log("🔹 Subtotal:", subTotal);
  console.log("🔹 GST (18%):", gstAmount);
  console.log("🔹 Total Amount:", totalAmount);
  //console.log("🔹 Visibility Charges:", visibilityCharges);
  //console.log("🔹 Deposit Charges:", depositCharges);
  console.log("🔹 Sale Type:", saleType);

  // *📌 Page Border*
  doc.setLineWidth(0.5);
  doc.rect(5, 5, 200, 287);

  // *📌 Header Section*
  if (anotherLogo) {
    const anotherImage = new Image();
    anotherImage.src = anotherLogo;
    doc.addImage(anotherImage, "PNG", 10, 10, 40, 20);
  }
  if (logo) {
    const image = new Image();
    image.src = logo;
    doc.addImage(image, "PNG", 160, 10, 40, 20);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("PERFORMA INVOICE", 105, 30, { align: "center" });
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text(`Date: ${formattedDate}`, 10, 45);
  doc.text(`Invoice ID: ${invoiceId}`, 10, 50);

  // *📌 Company & Seller Details*
  const companyDetails = `
OGCS Private Limited, BuildPro OGCS
Navin Panvel, Dist: Raigad, Pin Code: 410206
Contact: +91 9967610135
Email: support@buildproogcs.com
GST: 27AAEC01131F1ZW`;

  const sellerDetailsText = `
Seller Details:
${sellerDetails.name}
${sellerDetails.address?.street || ""}
${sellerDetails.address?.city || ""}, ${sellerDetails.address?.state || ""},
${sellerDetails.address?.country || ""} - ${sellerDetails.address?.postalCode || ""}
Contact: ${sellerDetails.mobile}
Email: ${sellerDetails.email}
PAN: ${sellerDetails.pan || "-"}
GST: ${sellerDetails.gstNumber || "-"}`;

  doc.setFontSize(9);
  doc.text(companyDetails, 10, 65);
  doc.text(sellerDetailsText, 110, 65);

  // *📌 Product Table*
  const tableHeaders = ["Name", "Amount (Rs)", "Max Qty", "Visibility Level", "HSN Code", "Remarks"];
  const tableData = products.map((product) => [
    product.productName,
    `Rs ${product.productPrice}`,
    product.maxquantity,
    product.visibilityLevel,
    product.hsncode,
    "-",
  ]);

  // *📌 Add Additional Charges to Table*
  tableData.push(
   // ["Visibility Charges", Rs ${visibilityCharges.toFixed(2)}, "-", "-", "-", "-"],
    ["PowerPack Charges", `Rs ${powerPackCharges.toFixed(2)}`, "-", "-", "-", "-"],
    //["Deposit Charges", Rs ${depositCharges.toFixed(2)}, "-", "-", "-", "-"],
    ["Subtotal", `Rs ${subTotal.toFixed(2)}`, "-", "-", "-", "-"],
    ["GST (18%)", `Rs ${gstAmount.toFixed(2)}`, "-", "-", "-", "-"],
    ["Total Amount", `Rs ${totalAmount.toFixed(2)}`, "-", "-", "-", "-"]
  );


  // if (saleType === "Sale By Seller") {
  //   tableData.push(["Visibility Charges", Rs ${visibilityCharges.toFixed(2)}, "-", "-", "-", "-"]);
  // }

  // if (saleType === "Sale By OGCS") {
  //   tableData.push(["Deposit Charges", Rs ${depositCharges.toFixed(2)}, "-", "-", "-", "-"]);
  // }
  
  doc.autoTable({
    head: [tableHeaders],
    body: tableData,
    startY: 110,
    theme: "grid",
    margin: { left: 10, right: 10 },
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  });

  // *📌 Footer Section (Bank Details & Thank You)*
  const footerY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text("Bank Details:", 10, footerY);
  doc.setFontSize(9);
  doc.text(
    `Bank Name: HDFC Bank
Account Name: OGCS Private Limited
Account Number: 50200084105798
IFSC Code: HDFC0000256
Branch: New Panvel`,
    10,
    footerY + 5
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Thank you for connecting with BuildPro OGCS!", 105, footerY + 30, { align: "center" });
  doc.setFontSize(10);
  doc.text("For assistance, contact our support team.", 105, footerY + 40, { align: "center" });

  // *📌 Save PDF*
  doc.save(`Proforma_Invoice.pdf`);
};

export default generateInvoice;